import moment from 'moment';

export const exportUtils = {
    methods: {
        exportData(data, filename) {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";

            var blob = new Blob([data], {
                type: 'octet/stream'
            });

            var url = window.URL.createObjectURL(blob);      
            a.href = url;
            a.download = `${filename}.xlsx`;        
            a.click();
            window.URL.revokeObjectURL(url);      
        },
        exportDataCorupt(data, filename) {
            const blob = new Blob(
                [data], { type: 'octet/stream' })
                const aEle = document.createElement('a');     // Create a label
                const href = window.URL.createObjectURL(blob);       // Create downloaded link
                aEle.href = href;
                aEle.download = filename+'.xlsx';  // File name after download
                document.body.appendChild(aEle);
                aEle.click();     // Click to download
                document.body.removeChild(aEle); // Download complete remove element
                window.URL.revokeObjectURL(href) 
        }
    }
}